/** Three's XR union uses world-space IPD with meter-space XR projection planes.
 * A scaled presentation rig therefore needs meter-space union projection
 * offsets. Keep Three's world-space union pose, which is already correct.
 * Call after xr.updateCamera and disable automatic camera updates at render.
 */
export function correctScaledXRUnion(cameraXR, unitsPerMeter = 1) {
  if (!Number.isFinite(unitsPerMeter) || unitsPerMeter <= 0) throw new TypeError('Positive XR units per meter required');
  const eyes = cameraXR?.cameras;
  if (unitsPerMeter === 1 || eyes?.length !== 2) return cameraXR;
  const [left, right] = eyes, l = left.matrixWorld.elements, r = right.matrixWorld.elements;
  const ipd = Math.hypot(l[12] - r[12], l[13] - r[13], l[14] - r[14]) / unitsPerMeter;
  const pl = left.projectionMatrix.elements, pr = right.projectionMatrix.elements;
  if (pl[10] === -1) {
    cameraXR.projectionMatrix.copy(left.projectionMatrix);
  } else {
    const near = pl[14] / (pl[10] - 1), far = pl[14] / (pl[10] + 1);
    const top = (pl[9] + 1) / pl[5], bottom = (pl[9] - 1) / pl[5];
    const leftFov = (pl[8] - 1) / pl[0], rightFov = (pr[8] + 1) / pr[0];
    const z = ipd / (-leftFov + rightFov), x = z * -leftFov;
    const near2 = near + z, far2 = far + z;
    cameraXR.projectionMatrix.makePerspective(near * leftFov - x, near * rightFov + ipd - x,
      top * far / far2 * near2, bottom * far / far2 * near2, near2, far2);
  }
  cameraXR.projectionMatrixInverse.copy(cameraXR.projectionMatrix).invert();
  return cameraXR;
}
